/* EDUARD-CUSTOM
   Begleitskript zu assets/eduard-product-readmore.css.

   Das Auf- und Zuklappen selbst macht CSS (versteckte Checkbox). Dieses
   Skript sucht die Stelle, an der abgeschnitten wird — und zwar an einer
   SATZGRENZE, nicht mitten im Satz.

   Zwei Schnittmodi, einstellbar in der Section:

   MODUS "paragraph" — nach dem ersten Absatz. Der sichtbare Teil endet am
   Absatzende, also ohnehin an einem Satzende. Fuer lange Erzaehltexte, bei
   denen der erste Absatz der Anreisser ist. Gibt es nur einen Absatz, wird
   nicht geschnitten.

   MODUS "lines" — nach Zeilen, und dann gilt:
     - Vier Zeilen sind die Referenz, eine fuenfte ist erlaubt, wenn der
       Satz erst dort endet (Zielzeilen + Spielraum, beides aus den
       Section-Einstellungen).
     - Unter allen Satzenden gewinnt das, dessen Zeilenzahl am dichtesten an
       den vier Zeilen liegt. Bei Gleichstand — etwa drei gegen fuenf — das
       laengere, weil die fuenfte Zeile ausdruecklich erlaubt ist.
     - Hinter dem sichtbaren Satz steht " …": Der Schlusspunkt bleibt stehen,
       die Auslassungspunkte zeigen, dass es weitergeht.
     - Passt gar kein Satz in den Rahmen (ein einzelner Satz laenger als der
       Spielraum), wird an der letzten Wortgrenze innerhalb der Zielzeilen
       geschnitten — immer noch besser als mitten im Wort.
     - Passt der ganze Text ohnehin in den Rahmen, wird nichts geschnitten
       und der Link verschwindet.

   Faellt das Skript aus, klemmt das CSS hart auf die Zielzeilen. Der Link
   funktioniert auch dann. */
(function () {
  'use strict';

  var SELECTOR = '[data-pib-readmore]';
  var FITS = 'data-pib-rm-fits';
  var SENTENCE = 'data-pib-rm-sentence';
  var CUT = 'pib__rm-cut';
  var ELL = 'pib__rm-ell';
  var LAST = 'pib__rm-last';

  // Woerter, die auf einen Punkt enden, ohne einen Satz zu beenden.
  var ABK = ('bzw ca bspw etc evtl ggf inkl zzgl max min nr sog usw vgl ' +
             'dr prof st abb jh mio mrd tsd std sek ' +
             'approx vs mr mrs ms fig inc ltd co jr sr ' +
             'jan feb mrz apr jun jul aug sep sept okt nov dez').split(' ');

  var BUCHSTABE = /[A-Za-zÀ-ɏ]/;
  var SCHLIESSER = '"“”’»›)]«';
  var SATZANFANG = /^\s+["„«‘’(\[A-ZÄÖÜ0-9]/;

  function istAbkuerzung(text, punkt) {
    var i = punkt - 1, wort = '';
    while (i >= 0 && BUCHSTABE.test(text.charAt(i))) { wort = text.charAt(i) + wort; i--; }
    if (wort.length === 0) return false;
    if (wort.length === 1) return true;  // "z.", "B.", "e.", "g." — nie ein Satzende
    return ABK.indexOf(wort.toLowerCase()) !== -1;
  }

  function textknoten(body) {
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false);
    var liste = [], n;
    while ((n = walker.nextNode())) liste.push(n);
    return liste;
  }

  function satzgrenzen(body) {
    var knoten = textknoten(body), out = [];
    for (var k = 0; k < knoten.length; k++) {
      var t = knoten[k].nodeValue;
      for (var i = 0; i < t.length; i++) {
        var c = t.charAt(i);
        if (c !== '.' && c !== '!' && c !== '?' && c !== '…') continue;

        var ende = i + 1;
        while (ende < t.length && SCHLIESSER.indexOf(t.charAt(ende)) !== -1) ende++;
        // Mehrere Satzzeichen hintereinander ("?!") zaehlen als eines.
        if (ende < t.length && '.!?…'.indexOf(t.charAt(ende)) !== -1) continue;

        var danach = t.slice(ende);
        if (danach.length && !/^\s*$/.test(danach)) {
          // "10.000" — auf den Punkt folgt kein Leerraum
          if (!/^\s/.test(danach)) continue;
          // Danach faengt kein neuer Satz an
          if (!SATZANFANG.test(danach)) continue;
        }
        if (c === '.' && istAbkuerzung(t, i)) continue;

        out.push({ node: knoten[k], offset: ende });
      }
    }
    return out;
  }

  function wortgrenzen(body) {
    var knoten = textknoten(body), out = [];
    for (var k = 0; k < knoten.length; k++) {
      var t = knoten[k].nodeValue;
      for (var i = 1; i < t.length; i++) {
        if (/\s/.test(t.charAt(i)) && !/\s/.test(t.charAt(i - 1))) {
          out.push({ node: knoten[k], offset: i });
        }
      }
    }
    return out;
  }

  function ersterTextknoten(body) {
    var knoten = textknoten(body);
    for (var i = 0; i < knoten.length; i++) {
      if (/\S/.test(knoten[i].nodeValue)) return knoten[i];
    }
    return null;
  }

  // Zeilen zaehlen ueber die verschiedenen Oberkanten der Zeilenrechtecke.
  // Zuverlaessiger als durch die Zeilenhoehe zu teilen: Absatzabstaende und
  // Inline-Auszeichnungen wuerden diese Rechnung verfaelschen.
  function zeilen(range) {
    var rects = range.getClientRects(), gesehen = {}, anzahl = 0;
    for (var i = 0; i < rects.length; i++) {
      if (rects[i].width <= 0 && rects[i].height <= 0) continue;
      var key = Math.round(rects[i].top);
      if (!gesehen[key]) { gesehen[key] = 1; anzahl++; }
    }
    return anzahl;
  }

  function zeilenBis(erster, grenze) {
    var r = document.createRange();
    try {
      r.setStart(erster, 0);
      r.setEnd(grenze.node, grenze.offset);
    } catch (e) { return 0; }
    return zeilen(r);
  }

  function zeilenGesamt(body) {
    var r = document.createRange();
    r.selectNodeContents(body);
    return zeilen(r);
  }

  function waehleGrenze(body, erster, ziel, maximum) {
    var kand = satzgrenzen(body);
    var beste = null, besteZeilen = 0, besterAbstand = Infinity;

    for (var i = 0; i < kand.length; i++) {
      var z = zeilenBis(erster, kand[i]);
      if (z < 1) continue;
      if (z > maximum) break;  // ab hier wird es nur noch laenger
      var abstand = Math.abs(z - ziel);
      if (abstand < besterAbstand || (abstand === besterAbstand && z > besteZeilen)) {
        beste = kand[i]; besteZeilen = z; besterAbstand = abstand;
      }
    }
    if (beste) return beste;

    // Kein Satz passt in den Rahmen: an der letzten Wortgrenze innerhalb der
    // Zielzeilen schneiden.
    var worte = wortgrenzen(body), letzte = null;
    for (var j = 0; j < worte.length; j++) {
      var zz = zeilenBis(erster, worte[j]);
      if (zz > ziel) break;
      if (zz >= 1) letzte = worte[j];
    }
    return letzte;
  }

  // Modus "paragraph": Das Ende des ersten Absatzes. Als Absatz zaehlt das
  // erste Block-Element mit Text — bei einem Rich-Text-Metafeld steckt es in
  // einem <div class="metafield-rich_text_field">, deshalb wird gesucht und
  // nicht das erste Kind genommen.
  function absatzGrenze(body) {
    var block = body.querySelector('p, li, blockquote, h1, h2, h3, h4, h5, h6');
    if (!block) return null;
    var walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, null, false);
    var letzter = null, n;
    while ((n = walker.nextNode())) { if (n.nodeValue.length) letzter = n; }
    if (!letzter) return null;
    return { node: letzter, offset: letzter.nodeValue.length };
  }

  // Steht hinter der Grenze ueberhaupt noch Text? Wenn nicht, gibt es nichts
  // aufzuklappen — dann faellt der Link weg, statt ins Leere zu zeigen.
  function restHatText(body, grenze) {
    var r = document.createRange();
    try {
      r.setStart(grenze.node, grenze.offset);
      r.setEnd(body, body.childNodes.length);
    } catch (e) { return true; }
    return /\S/.test(r.toString());
  }

  function markiere(node) {
    if (node.nodeType === 1) { node.className += (node.className ? ' ' : '') + CUT; return; }
    if (node.nodeType === 3 && node.parentNode) {
      var span = document.createElement('span');
      span.className = CUT;
      node.parentNode.insertBefore(span, node);
      span.appendChild(node);
    }
  }

  function schneiden(body, grenze) {
    var rest;
    try { rest = grenze.node.splitText(grenze.offset); } catch (e) { return false; }

    // Erst sammeln, dann anfassen: das Markieren haengt Knoten um.
    var folgende = [], s = rest;
    while (s) { folgende.push(s); s = s.nextSibling; }
    var cur = rest.parentNode;
    while (cur && cur !== body) {
      var t = cur.nextSibling;
      while (t) { folgende.push(t); t = t.nextSibling; }
      cur = cur.parentNode;
    }

    var ell = document.createElement('span');
    ell.className = ELL;
    ell.textContent = ' …';  // geschuetztes Leerzeichen, damit " …" nicht umbricht
    rest.parentNode.insertBefore(ell, rest);

    for (var i = 0; i < folgende.length; i++) markiere(folgende[i]);

    // Der Absatz, in dem geschnitten wurde, ist im zugeklappten Zustand der
    // letzte sichtbare — sein Abstand nach unten gehoert dem Link, nicht ihm.
    // Gesucht ist das naechste BLOCK-Element ueber der Schnittstelle, nicht
    // das aeusserste: Ein Rich-Text-Metafeld rendert als
    // <div class="metafield-rich_text_field"> um die <p> herum, und den
    // Abstand traegt das <p>, nicht der div.
    var blk = ell.parentNode;
    while (blk && blk !== body && blk.nodeType === 1 &&
           window.getComputedStyle(blk).display === 'inline') {
      blk = blk.parentNode;
    }
    if (blk && blk !== body && blk.nodeType === 1) blk.className += (blk.className ? ' ' : '') + LAST;

    return true;
  }

  // Echte Zeilenhoehe: die des ersten Textkindes, nicht die des Containers.
  // .pib__body steht auf 16px/1.55, die Absaetze darin auf 18px/28.08px.
  function lineHeightOf(body) {
    var first = body.querySelector('p, li, blockquote, h1, h2, h3, h4, h5, h6') || body;
    var lh = parseFloat(window.getComputedStyle(first).lineHeight);
    if (!lh || isNaN(lh)) {
      var fs = parseFloat(window.getComputedStyle(first).fontSize) || 16;
      lh = fs * 1.55;
    }
    return lh;
  }

  function measure(wrap) {
    var body = wrap.querySelector('.pib__body');
    var box = wrap.querySelector('.pib__rm-cb');
    if (!body || !box) return;

    var wasOpen = box.checked;

    // Immer vom Urzustand aus rechnen: Bei anderer Breite bricht der Text
    // anders um, und die richtige Satzgrenze liegt dann woanders.
    if (body.getAttribute('data-pib-rm-kept') === null) {
      body.setAttribute('data-pib-rm-kept', '');
      body.__pibRmOriginal = body.innerHTML;
    } else if (typeof body.__pibRmOriginal === 'string') {
      body.innerHTML = body.__pibRmOriginal;
    }

    wrap.removeAttribute(FITS);
    wrap.removeAttribute(SENTENCE);

    var stil = window.getComputedStyle(wrap);
    var modus = (stil.getPropertyValue('--pib-rm-mode') || '').replace(/["'\s]/g, '');
    var ziel = parseFloat(stil.getPropertyValue('--pib-rm-lines')) || 4;
    var extra = parseFloat(stil.getPropertyValue('--pib-rm-extra'));
    if (isNaN(extra) || extra < 0) extra = 1;
    var maximum = ziel + extra;

    // Rueckfall-Klemmung fuer den Fall, dass unten nichts geschnitten wird.
    // Im Absatz-Modus waere sie falsch — dort bestimmt der Absatz die Hoehe,
    // nicht eine Zeilenzahl.
    if (modus === 'paragraph') wrap.style.removeProperty('--pib-rm-h');
    else wrap.style.setProperty('--pib-rm-h', (lineHeightOf(body) * ziel) + 'px');

    // Fuer die Messung aufklappen, sonst verdeckt die Klemmung das Layout.
    box.checked = true;

    var erster = ersterTextknoten(body);
    if (!erster) { box.checked = wasOpen; return; }

    var grenze;
    if (modus === 'paragraph') {
      grenze = absatzGrenze(body);
      // Ein einziger Absatz: nichts zu kuerzen.
      if (!grenze || !restHatText(body, grenze)) {
        wrap.setAttribute(FITS, '');
        box.checked = false;
        return;
      }
    } else {
      if (zeilenGesamt(body) <= maximum) {
        wrap.setAttribute(FITS, '');
        box.checked = false;
        return;
      }
      grenze = waehleGrenze(body, erster, ziel, maximum);
    }

    if (grenze && schneiden(body, grenze)) wrap.setAttribute(SENTENCE, '');

    box.checked = wasOpen;
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) measure(list[i]);
    // Der Bereich selbst kann das Ziel sein (Theme-Editor laedt Sections einzeln nach).
    if (scope !== document && scope.matches && scope.matches(SELECTOR)) measure(scope);
  }

  // Erst sofort rechnen, dann im naechsten Frame noch einmal nachziehen.
  // requestAnimationFrame allein reicht NICHT: In einem Tab, der im
  // Hintergrund geoeffnet wurde, feuert es nicht — dort waere die Klemmung
  // nie korrigiert worden. Das betrifft jeden, der einen Produktlink per
  // Mittelklick oeffnet.
  function schedule() {
    run();
    if (window.requestAnimationFrame) window.requestAnimationFrame(function () { run(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Bilder und spaet geladene Schriften aendern den Umbruch noch einmal.
  window.addEventListener('load', schedule);
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(schedule).catch(function () {});
  }

  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(schedule, 150);
  });

  // Ein im Hintergrund geladener Tab hat noch kein Layout gerechnet.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') schedule();
  });

  // Theme-Editor: Section neu geladen oder Einstellung geaendert.
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('shopify:section:select', function (e) { run(e.target); });
})();
